export default {
  title:
    " Authing身份云-SSO单点登录系统-MFA多因素认证-统一身份认证平台-中国版OKTA-零信任-IDaaS-以开发者为中心",
  banner: {
    item1: {
      title: "",
      title2: "就是身份云",
      subtitle:
        "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理，为你的客户和员工提供完善的登录解决方案",
      subtitleSmall:
        "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理",
    },
    item2: {
      title: "入选 Gartner，",
      title2: "位列身份云赛道首位",
      subtitle:
        "Authing 入选 Gartner《2022 中国网络安全技术成熟度曲线》，荣获 BYOI 领域的 Sample Vendor，并在 IAM 领域位列首位。",
      subtitleSmall:
        "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理",
    },
    item3: {
      title: "身份云社区｜开发者专享",
      title2: "CSDN x Authing 独家战略合作 ",
      subtitle:
        "Authing 非常荣幸与中国 IT 社区引领者 CSDN 携手推动身份云在开发者圈子中的普及与实践，共建专业、优质、友好的开发者生态。",
      subtitleSmall:
        "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理",
    },
    item4: {
      title: "Authing ",
      title2: "2022 年度回顾",
      subtitle:
        "截至 2022 年，我们服务了 3W+ 企业和开发者，帮助客户提升 ROI 548%。2023 年，Authing 也将再接再厉，继续连接全球人与应用！",
      subtitleSmall:
        "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理",
    },
  },
  guard: {
    title: "Authing 始于登录",
    subtitle: "5 行代码即刻拥有安全、稳定、强大的身份模块",
    tooltip: "注册 Authing，免费探索更多功能！",
    "guard-ui": {
      title: "全局登录框设置",
      doc: "查看文档",
      left: {
        baseSetting: "常规登录设置",
        password: "忘记密码",
        socialAccount: "社交账号登录",
        companyAccount: "企业账号登录",
        funcSetting: "功能配置",
        loginProtal: "登录注册协议",
        add: "添加",
        loginAdd: "登录注册信息补全",
        loginAddSub:
          "开启后，用户在登录/注册时会被要求补全 手机、邮箱等信息，可设置是否为必填",
        loginInfo: "登录时信息补全",
        resignInfo: "注册时信息补全",
      },
      center: {
        title: "欢迎登录",
        passLogin: "密码登录",
        rcode: "验证码登录",
        account: "输入账号",
        password: " 输入登录密码",
        login: "登录",
        forgetPass: "忘记密码",
        regist: "立即注册",
        thirdLogin: "第三方账号登录",
        lang: "简体中文",
      },
      right: {
        code: "零代码",
        css: "自定义 CSS",
        backgorund: "自定义背景",
        color: "纯色背景",
        picture: "图片背景",
        icon: "自定义加载图标",
        upload: "上传图标",
        language: "语言设置",
        switch: "切换语言",
        default: "默认语言",
        system: "跟随系统",
      },
      brand: "你的品牌",
      tech: "科技行业",
      manual: "制造行业",
      finance: "金融行业",
    },
  },
  order1: {
    title: "免费体验 Authing 所有功能",
    subtitle: "注册即可享受 Authing 高级版身份认证、授权、访问管理等权益！",
    titleSmall: "享受完整权益",
    subtitleSmall: "限时体验所有功能",
  },
  order2: {
    title: "先进制造行业解决方案",
    subtitle: "增强身份管理与安全体系，支撑高精尖产业与企业的稳步增长",
    titleSmall: "构建 IDaaS",
    subtitleSmall: "升级本土化 IAM",
  },
  order3: {
    title: "银行/证券/基金行业解决方案",
    subtitle: "统一身份，在保证数据安全的同时提升企业管理效能与金融服务体验",
    titleSmall: "金融行业方案",
    subtitleSmall: "提升金融服务体验",
  },
  order4: {
    title: "科技/互联网行业",
    subtitle: "对应用矩阵、用户身份进行打通和统一，高效集成内外部 N 个软件系统",
    titleSmall: "科技行业方案",
    subtitleSmall: "高效集成应用矩阵",
  },
  api: {
    "title-dot-one": "用",
    "title-dot-two": "，帮",
    "title-dot-three": "省",
    "title-dot-one-first": "完善的 API",
    "title-dot-one-second": "统一的管理",
    "title-dot-one-third": "灵活的登录",
    "title-dot-two-first": "开发者",
    "title-dot-two-second": "企业",
    "title-dot-two-third": "用户",
    "title-dot-three-first": "时",
    "title-dot-three-second": "钱",
    "title-dot-three-third": "事",
    roi: {
      userRate: "终端用户转化率",
      maintenanceCost: "运维成本",
      developmentTime: "开发工时",
      dataFrom: "数据来源于 GARTNER",
    },
    doc: {
      type: "文档",
      title: "快速开始",
      descript: "学习使用 Authing 及我们提供的 API",
    },
    community: {
      type: "社区",
      title: "开发者论坛",
      descript: "与 Authing 的工程师和用户在线交流",
    },
  },
  product: {
    title: "Authing 不止登录",
    product1: {
      title: "单点登录 SSO",
      titleSmall: "单点登录",
      subtitle:
        "在多个应用系统中，只需登录一次，即可访问所有相互信任的应用系统，进一步实现统一身份管理。",
    },
    // product2: {
    //   title: "账号全生命周期自动化",
    //   titleSmall: "同步中心",
    //   subtitle:
    //     "帮助企业便捷同步上游用户数据至下游应用，降低手动维护账号的成本，减少安全问题。",
    // },
    product2: {
      title: "",
      titleSmall: "身份自动化",
      subtitle:
        "帮助企业灵活编排身份管理流程，自动触发数据流与业务流，降低维护成本，减少安全问题。",
    },
    product3: {
      title: "手机号码闪验",
      titleSmall: "号码闪验",
      subtitle:
        "用户一键授权即可以真实号码完成注册/登录，为开发者建立以手机号码为基础的账号体系。",
    },
    product4: {
      title: "应用集成网关",
      titleSmall: "集成网关",
      subtitle:
        "为老旧应用高效的扩充身份认证能力，并保护原有系统资源免受非法侵害。",
    },
    product5: {
      title: "权限管理",
      titleSmall: "权限管理",
      subtitle:
        "基于角色和属性的访问控制，让企业实现动态、细粒度的授权，统一权限管理。",
    },
    product6: {
      title: "通用登录组件",
      titleSmall: "登录组件",
      subtitle:
        "一种可嵌入的登录表单，可以根据需求进行自定义配置，轻松添加各种社会化登录方式。",
    },
    product7: {
      title: "自定义数据库连接",
      titleSmall: "数据库迁移",
      subtitle:
        "自定义数据库连接方案，支持企业连接自身维护的数据库，也支持通过“惰性迁移”将老旧系统的数据安全上云。",
    },
    product8: {
      title: "2000+ 应用快速集成",
      titleSmall: "应用市场",
      subtitle:
        "集成 2000+ 国内外主流应用：企业微信、钉钉、阿里云、蓝凌OA、CRM 等，帮助企业更快速高效的接入、打通多个系统。",
    },
    product9: {
      title: "多因素认证 MFA",
      titleSmall: "多因素认证",
      subtitle:
        "在用户名和密码之外再额外增加一层安全保护，在不牺牲用户体验的情况下进行安全身份验证。 ",
    },
    product10: {
      title: "全场景微信登录方案",
      titleSmall: "微信登录",
      subtitle:
        "Authing 针对微信生态场景，为开发者提供简洁、统一的 SDK。只需简单调用，无需操心各种复杂的身份识别逻辑。",
    },
    product11: {
      title: "全面替代 IAM",
      titleSmall: "替代 IAM",
      subtitle:
        "IDaaS 相较于 IAM，能为企业带来更多收益：提升营销和运营效率；加速新业务上线；提升安全性降低网络攻击风险；提升用户体验。",
    },
    product12: {
      title: "多租户",
      titleSmall: "多租户",
      subtitle:
        "帮助企业快速构建多租户管理架构，无需从 0 构建，快速实现数据和资源权限隔离。",
    },
  },
  solution: {
    title: "新一代全场景身份云",
    tabs: {
      tab1: {
        label: "行业解决方案",
        desc: "你所在的行业，都在重构身份管理体系",
      },
      tab3: {
        label: "国产化替代",
        desc: "你所用的服务，有更省钱省时的替代",
      },
    },
    firstProducts: {
      firstProducts1: {
        title: "科技/互联网",
        subtitle:
          "统一应用矩阵的登录与认证体系，让科技产品拥有科技感的身份管理",
      },
      firstProducts2: {
        title: "先进制造",
        subtitle: "尽早建立机密保护与身份安全体系，支撑智能产品与企业高速增长",
      },
      firstProducts3: {
        title: "银行/证券/基金",
        subtitle: "私有化部署，对内统一登录与认证，对外提升金融服务体验",
      },
      firstProducts4: {
        title: "医疗/医药",
        subtitle: "提高身份管理规范、精细管理设备权限，保护患者隐私和科研数据",
      },
      firstProducts5: {
        title: "新消费",
        subtitle:
          "用户需要更快更好的线上购买体验，你需要从第一步登录认证做出改变",
      },
      firstProducts6: {
        title: "地产",
        subtitle:
          "同步多个系统的异构数据，实现万级员工、业主、住户的管理自动化",
      },
      firstProducts7: {
        title: "游戏",
        subtitle: "快速上线身份自动化，让游戏从登录那刻起就让人沉迷",
      },
      firstProducts8: {
        title: "教育",
        subtitle:
          "打造安全、共享、统一的校园身份体系和在线教育登录服务，让知识触手可及",
      },
      firstProducts9: {
        title: "汽车",
        subtitle: "高效安全的集成登录应用，让研发精力专注于流畅优雅的驾车体验",
      },
      firstProducts10: {
        title: "企业服务",
        subtitle: "企业需要高效协同上下游伙伴，你可以通过统一的认证和管理实现",
      },
      firstProducts11: {
        title: "政府机构",
        subtitle: "让公民用一个账号安全登录所有政务系统，助力数字化改革",
      },
    },
    thirdProducts: {
      thirdProducts1: {
        title: "微软 AD 增强",
        subtitle: "通过 AD 身份增强方案，配合企业高速发展",
        contentListValue1: "提高扩展性",
        contentListValue2: "丰富使用场景",
        contentListValue3: "提升信息化转型效率",
      },
      thirdProducts2: {
        title: "全面替代 Okta",
        subtitle: "替代 Okta，提供快速稳定的身份服务",
        contentListValue1: "提供身份中台、工作流、目录",
        contentListValue2: "提供应用集成、用户分析、开发组件",
        contentListValue3: "更加适配国产应用",
      },
      thirdProducts3: {
        title: "全面替代 AWS Cognito",
        subtitle: "使用 Authing User Pool，建立 AWS 访问桥梁",
        contentListValue1: "更安全的访问 AWS 服务",
        contentListValue2: "更有效的 API 保护",
        contentListValue3: "为国产应用接入 Cognito 功能",
      },
    },
  },
  customer: {
    title: "4W+ 家企业和开发者已经选择 Authing",
    productLists1: {
      firm: "—— PingCAP",
      content:
        "使用 Authing 统一多个身份源，打通国内外数据，实现 40+ 应用的单点登录、协同办公和身份供应，灵活高效。",
    },
    productLists2: {
      firm: "—— BOSCH",
      content:
        "Authing 对开发者友好，实施快速，基础设施要求门槛低，能够大幅节省部署及研发的时间成本。",
    },
    productLists3: {
      title: "海底捞",
      firm: "—— 海底捞",
      content:
        "Authing 与海底捞携手搭建统一身份中台，打通 80+ 自研和外采应用，实现细粒度的权限管理和员工身份自动化，树立餐饮行业信息化标杆。",
    },
    productLists4: {
      firm: "—— 奔特利",
      content:
        "Authing 为奔特利（Bentley）内部开发者和外部用户提供无缝、便捷的认证体验，保障其登录和身份验证时的安全性。",
    },
    productLists5: {
      firm: "—— CSDN",
      content:
        "Authing 开箱即用的 API 和 SDK，帮我们缩短 1 个月的研发周期，并打造强大的 One-ID 身份管理中台，提升用户体验。",
    },
  },
  multiply: {
    title: "安全的未来，现在连接",
    "button-text": "立即查看",
    catalogue1: {
      title: "三级等保&ISO",
      subtitle: "三级等保和 ISO 安全认证",
      text: "荣获资质",
      subtext: "荣获多项安全认证并选为创新企业",
      compliance1: "zero-trust-compliance1.png",
      compliance2: "zero-trust-compliance2.png",
      compliance3: "zero-trust-compliance3.png",
      compliance4: "zero-trust-compliance4.png",
      compliance5: "zero-trust-compliance5.png",
      compliance6: "zero-trust-compliance6.png",
      compliance7: "zero-trust-compliance7.png",
      contentLists1: {
        title: "ISO 认证",
        desc: "获得「服务管理体系认证」和「信息安全管理体认证」",
      },
      contentLists2: {
        title: "三级等保",
        desc: "获得《公安部信息安全等级保护三级认证》",
      },
      contentLists3: {
        title: "高新技术",
        desc: "被科技部选为「2021 国家高新技术企业」",
      },
      contentLists4: {
        title: "网络安全",
        desc: "连续两年收录自《中国网络安全产业白皮书》",
      },
      contentLists5: {
        title: "数据保护",
        desc: "通过欧盟「GDPR」《通用数据保护案例》",
      },
    },
    catalogue2: {
      title: "加入 W3C 组织",
      subtitle: "参与 W3C 国际标准制定",
      text: "Authing 正式加入 W3C 组织",
      subtext: "Authing 正式加入 W3C 组织，将参与相关国际标准制定",
    },
    catalogue3: {
      title: "入选 CNCF 图谱",
      subtitle: "国内唯一入选的云原生 IDaaS ",
      text: "Authing 入选 CNCF Landscape",
      subtext:
        "Authing 作为国内唯一的云原生 IDaaS 项目，被「CNCF Landscape」收录在 Key Management 中",
    },
    catalogue4: {
      title: "入选福布斯亚洲",
      subtitle: "入选“最值得关注公司”",
      text: "福布斯亚洲“最值得关注公司”百强榜单",
      subtext:
        "Authing 入选福布斯亚洲“最值得关注公司”百强榜单；创始人谢扬入选“福布斯亚洲 30 Under 30”",
    },
  },
};
